export enum SearchSourcePreference {
    None,
    SubstrateSearch,
    LegacySearch,
}
